import React from 'react';
interface ReassuranceProps {
  items: string[];
  tone?: 'light' | 'dark';
  className?: string;
}

/**
 * Compact trust line used under every CTA.
 */
export function Reassurance({
  items,
  tone = 'light',
  className = ''
}: ReassuranceProps) {
  return <ul className={`flex flex-wrap items-center justify-center gap-x-1.5 gap-y-0.5 text-[0.7rem] leading-tight sm:text-xs ${tone === 'dark' ? 'text-violet-200' : 'text-gray-500'} ${className}`} data-id="element-160" data-mp="j9574nf2ip8e">
      {items.map((item, i) => <li key={item} className="flex items-center gap-1.5" data-id="element-161" data-mp="o9b3ggwa8zwt" data-mpi={i}>
          {i > 0 && <span aria-hidden="true" className="opacity-50" data-id="element-162" data-mp="12zibe2onz0j9">
              ·
            </span>}
          <span data-id="element-163" data-mp="y16z7lawcdxv">{item}</span>
        </li>)}
    </ul>;
}